const AppLayout = (resolve) =>
  require(['@/components/layout/AppLayout'], resolve);
const _import = (path, subPath) =>
  require('@/components/page/user/' +
    path +
    (subPath ? `/${subPath}` : '/index'));

const routes = {
  path: '/user',
  component: AppLayout,
  meta: {
    title: 'user',
    hidden: true
  },
  redirect: 'center',
  children: [
    {
      path: 'center',
      name: 'user-personal-center',
      meta: {
        title: 'user.personal-center',
        hidden: true,
      },
      component: _import('center')
    },
  ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/user.js